import React from 'react'
import PropTypes from 'prop-types'
import { constants, array } from 'common/helpers'

import Section from 'components/smartSearch/SidebarSection/SidebarSection'
import Title from 'components/smartSearch/SidebarTitle/SidebarTitle'

import Link from '../Link/Link'


const SEOOtherLinks = ({ pathname, gender, tags }) => {
  const activeTags  = tags && tags[gender] && tags[gender].filter(({ productsCount }) => productsCount > 0) || []
  const groupedTags = array.groupBy(activeTags, 'type')

  return (
    <Section>
      {
        Object.keys(groupedTags).map((type) => (
          <Section key={type}>
            <Title title={type} />
            {
              groupedTags[type].map(({ name }) => {
                let link = '/'
                link += name.replace(/\s/g, '-').toLowerCase()

                if (constants.exceptionTags.includes(name)) {
                  link = `/tag${link}`
                }

                if ([ 'perfumes', 'colognes', 'fragrance' ].includes(pathname)) {
                  link += `-${pathname}`
                }
                else {
                  link += gender === 'female' ? '-perfumes' : '-colognes'
                }

                return (
                  <Link key={name} to={link}>{name}</Link>
                )
              })
            }
          </Section>
        ))
      }
    </Section>
  )
}

SEOOtherLinks.propTypes = {
  pathname: PropTypes.string.isRequired,
  gender: PropTypes.oneOf([ 'male', 'female' ]).isRequired,
  tags: PropTypes.object.isRequired,
}

SEOOtherLinks.defaultProps = {
  gender: 'female',
}


export default SEOOtherLinks
